import { Routes } from '@angular/router';
import {LoginComponent} from './auth/login/login.component';
import {AuthGuard, NotAuthGuard} from './auth.guard';
import {DashboardComponent} from './dashboard/dashboard.component';
import {ForgotPasswordComponent} from './auth/forgot-password/forgot-password.component';
import {
  ForgotPasswordConfirmationComponent
} from './auth/forgot-password-confirmation/forgot-password-confirmation.component';
import {NavCampaignsComponent} from './nav-campaigns/nav-campaigns.component';
import {ClientsComponent} from './clients/clients.component';
import {CampaignGroupsComponent} from './campaign-groups/campaign-groups.component';
import {CampaignsComponent} from './campaigns/campaigns.component';
import {AdgroupsComponent} from './adgroups/adgroups.component';
import {AdsComponent} from './ads/ads.component';
import {CampaignGroupSequenceComponent} from './campaign-group-sequence/campaign-group-sequence.component';
import {AdsMetaComponent} from './ads-meta/ads-meta.component';
import {AdgroupsMetaComponent} from './adgroups-meta/adgroups-meta.component';
import {CampaignsMetaComponent} from './campaigns-meta/campaigns-meta.component';
import {CampaignGroupsMetaComponent} from './campaign-groups-meta/campaign-groups-meta.component';
import {ClientsMetaComponent} from './clients-meta/clients-meta.component';
import {CampaignGroupSequenceMetaComponent} from './campaign-group-sequence-meta/campaign-group-sequence-meta.component';
import {
  CampaignGroupSequenceExperimentComponent
} from './campaign-group-sequence-experiment/campaign-group-sequence-experiment.component';
import {PlacementBuilderComponent} from './placement-builder/placement-builder.component';
import {PlacementBuilderMetaComponent} from './placement-builder-meta/placement-builder-meta.component';

export const routes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full'},
  { path: 'login',  component: LoginComponent, canActivate: [NotAuthGuard]},
  { path: 'dashboard',  component: DashboardComponent,  canActivate: [AuthGuard]},
  { path: 'forgot-password',  component: ForgotPasswordComponent, canActivate: [NotAuthGuard]},
  { path: 'forgot-password-confirmation',  component: ForgotPasswordConfirmationComponent, canActivate: [NotAuthGuard]},
  {path: 'nav-campaigns', component: NavCampaignsComponent, canActivate: [AuthGuard], children: [
      { path: 'dashboard',  component: DashboardComponent, canActivate: [AuthGuard],  outlet: 'admeta'},
      { path: 'clients',  component: ClientsComponent, canActivate: [AuthGuard],  outlet: 'admeta'},
      { path: 'clients-meta',  component: ClientsMetaComponent, canActivate: [AuthGuard],  outlet: 'admeta'},
      { path: "campaign-group-sequence-experiment", component: CampaignGroupSequenceExperimentComponent, canActivate: [AuthGuard], outlet: 'admeta'},
      { path: "campaign-group-sequence-experiment-meta", component: CampaignGroupSequenceExperimentComponent, canActivate: [AuthGuard], outlet: 'admeta'},
      { path: "campaign-group-sequence", component: CampaignGroupSequenceComponent, canActivate: [AuthGuard], outlet: 'admeta'},
      { path: "campaign-group-sequence-meta", component: CampaignGroupSequenceMetaComponent, canActivate: [AuthGuard], outlet: 'admeta'},
      { path: "campaign-groups", component: CampaignGroupsComponent, canActivate: [AuthGuard], outlet: 'admeta'},
      { path: "campaign-groups-meta", component: CampaignGroupsMetaComponent, canActivate: [AuthGuard], outlet: 'admeta'},
      { path: "campaigns", component: CampaignsComponent, canActivate: [AuthGuard], outlet: 'admeta'},
      { path: "campaigns-meta", component: CampaignsMetaComponent, canActivate: [AuthGuard], outlet: 'admeta'},
      { path: "adgroups", component: AdgroupsComponent, canActivate: [AuthGuard], outlet: 'admeta'},
      { path: "adgroups-meta", component: AdgroupsMetaComponent, canActivate: [AuthGuard], outlet: 'admeta'},
      { path: "ads", component: AdsComponent, canActivate: [AuthGuard], outlet: 'admeta'},
      { path: "ads-meta", component: AdsMetaComponent, canActivate: [AuthGuard], outlet: 'admeta'},
      { path: "placement-builder", component: PlacementBuilderComponent, canActivate: [AuthGuard], outlet: 'admeta'},
      { path: "placement-builder-meta", component: PlacementBuilderMetaComponent, canActivate: [AuthGuard], outlet: 'admeta'},

      //{path: 'clients', loadChildren: () => import('./clients/clients.module').then(m => m.ClientsModule), canActivate: [AuthGuard], outlet: 'admeta'},
    ]},
];
